<template>
  <div class="base-header">
    <div class="left-top-view">
      <img :class="isEnterpriseLogo ? 'enterprise-logo-icon' : 'logo-icon'" :src="headerLogo" alt=""/>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseHeader",
  inject: {
    enterpriseContentState: {
      default: () => ({ pcLogoUrl: '' })
    }
  },
  components: {},
  props: {},
  data() {
    return {
      defaultLogo: require('../../assets/image/home/left_logo_icon.png')
    }
  },
  computed: {
    isEnterpriseLogo() {
      return !!(this.enterpriseContentState && this.enterpriseContentState.pcLogoUrl)
    },
    headerLogo() {
      return this.enterpriseContentState && this.enterpriseContentState.pcLogoUrl ? this.enterpriseContentState.pcLogoUrl : this.defaultLogo
    }
  },
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {},
}
</script>

<style scoped lang="scss">
.base-header {
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
  overflow: auto;
  user-select: none;

  .left-top-view {
    background: var(--color-white-base);
    height: var(--pc-header-height);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    //padding-left: var(--padding-x-16);
    //border-bottom: var(--width-1) solid var(--color-gray-line-deep);
    position: sticky;
    top: 0;
    z-index: 999;

    .logo-icon {
      width: var(--width-264);
      height: var(--height-24);
    }

    .enterprise-logo-icon {
      width: auto;
      height: auto;
      max-height: 50px; /*no*/
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/layout/components/BaseHeader.vue